import React from 'react';

import {CycleMini, GlassesSparkle} from '@optimaxdev/icons';

import * as Pause from './img/pause.svg';
import * as Percent from './img/percent.svg';

import s from './cartItemTooltip.scss';

export const FAQ = [
    {
        anchor: 'How works?',
        description:
            'Your subscription order will arrive at your doorstep every 1, 3 or 6 months, according to your preference. You will be charged each time your lenses are shipped unless you cancel or pause your subscription.',
        title: 'How does the subscription work?',
    },
    {
        anchor: 'Change or cancel?',
        description:
            'You can cancel, change or pause your subscription at any time via the My Account page at GlassesUSA.com.  Make sure that you are logged in to update your preferences. You will not be charged a cancellation fee.',
        title: 'How do I change or cancel my subscription?',
    },
    {
        anchor: 'Any costs?',
        description: 'No, shipping is free, and we ship anywhere in the US.',
        title: 'Are there any extra shipping costs?',
    },
    {
        anchor: 'Prescription changes?',
        description:
            'That’s not a problem! If you have your new prescription, you can update us by chat or email and we will adjust your subscription order accordingly. If you don’t have your updated prescription, please contact us and we will assist you.',
        title: 'What happens if my prescription changes?',
    },
    {
        anchor: 'How to return?',
        description:
            'As always at GlassesUSA.com, your purchase is risk-free and includes free returns. You will get a full refund for any unopened boxes of contact lenses. You can start the returns process on our live chat. You’ll be sent a shipping label via email after you complete your return.',
        title: 'Can I return the lenses?',
    },
];

export const POPUP_ITEMS: {
    name: string;
    text: React.ReactNode;
    icon: any;
    iconWidth: number;
    className?: string;
}[] = [
    {
        className: s.blue,
        icon: GlassesSparkle,
        iconWidth: 20.7,
        name: 'glasses',
        text: (
            <>
                Get FREE prescription glasses
                <br />
                ($100 value)
            </>
        ),
    },
    {
        icon: CycleMini,
        iconWidth: 18.37,
        name: 'contacts',
        text: <>Always stay stocked up on contacts</>,
    },
    {
        icon: Pause,
        iconWidth: 12.67,
        name: 'modify',
        text: (
            <>
                Modify or cancel anytime,
                <br />
                no strings attached
            </>
        ),
    },
    {
        icon: Percent,
        iconWidth: 13.49,
        name: 'save',
        text: (
            <>
                Save 15% on all future orders
                <br />
                (and 25% OFF your first order)
            </>
        ),
    },
];
